import {Component, Input} from "@angular/core";

class Item {
  constructor(public text: string) { }
}

@Component({
  selector: "common-ngfor-item",
  template: `
    {{item?.text}}
    `,
})
class ItemComponent {
  @Input() item: Item;
}

@Component({
  selector: "common-ngfor",
  template: `
  <usecase-container title="NgFor" src="common/ngfor">
    <usecase-content>
      <div *ngFor="let item of items">
        <common-ngfor-item [item]="item"></common-ngfor-item>
      </div>
    </usecase-content>
  </usecase-container>
  `,
  directives: [ItemComponent]
})
export class NgForComponent {
  items: Item[] = [
    new Item("Angular"),
    new Item("React"),
    new Item("Vue"),
    new Item("Backbone"),
  ]
}



/** WEBPACK FOOTER **
 ** ./script/common/ngfor/component.ts
 **/